export type Route =
  | { name: 'home' }
  | { name: 'category'; slug: string }
  | { name: 'product'; slug: string }
  | { name: 'admin' }
  | { name: 'notFound' }

export function parseRoute(pathname: string): Route {
  const clean = pathname.replace(/\/+$/, '') || '/'

  if (clean === '/') return { name: 'home' }
  if (clean === '/admin' || clean.startsWith('/admin/')) return { name: 'admin' }

  const category = clean.match(/^\/category\/([^/]+)$/)
  if (category) return { name: 'category', slug: decodeURIComponent(category[1]) }

  const product = clean.match(/^\/product\/([^/]+)$/)
  if (product) return { name: 'product', slug: decodeURIComponent(product[1]) }

  return { name: 'notFound' }
}
